import { render, staticRenderFns } from "./PastEventDetail.vue?vue&type=template&id=5e3df58f"
import script from "./PastEventDetail.vue?vue&type=script&lang=js"
export * from "./PastEventDetail.vue?vue&type=script&lang=js"
import style0 from "./PastEventDetail.vue?vue&type=style&index=0&id=5e3df58f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports